import { Modal } from 'antd';
import { styled } from 'styled-components';

export const StyledModal = styled(Modal)`
  .ant-modal-header {
    display: none;
  }
  .ant-modal-body {
    padding: 0;
  }
`;
